import {Helmet} from "react-helmet";
import {RouteHelper} from "../../route/RouteHelper";
import {
    addNewRowToTable,
    DialogSize,
    RaikoBaseCardContainer,
    RaikoBaseContainer,
    RaikoBreadcrumb,
    raikoBreadCrumbItemGenerator,
    RaikoCustomTable,
    RaikoDefaultDialogPage,
    RaikoGridOneColumn, RaikoGridTwoColumn, RaikoMaterialOutlinedInput,
    RaikoSectionContainer,
    RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import React, {useEffect, useState} from "react";
import {FundService} from "../../serverService/fund/FundService";
import {useNavigate} from "react-router-dom";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {useDebounce} from "@uidotdev/usehooks";
import FundAddNewAdmin from "./FundAddNewAdmin";

export default function FundsAdmins() {

    const service = new FundService()

    const [page, setPage] = useState(1);
    const size = 25

    const [funds, setFunds] = useState([])
    const [totalItems, setTotalItems] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [tableLoading, setTableLoading] = useState(false);

    const [fullName, setFullName] = useState("");
    const [nationalCode, setNationalCode] = useState("");

    const fullNameFilter = useDebounce(fullName, 300)
    const nationalCodeFilter = useDebounce(nationalCode, 300)

    const navigate = useNavigate()

    useEffect(() => {
        getFundAdminsFromServer()
    }, [
        page,
        fullNameFilter,
        nationalCodeFilter
    ]);


    function prepareFundsListItem(number, id, firstName, lastName, fundName, nationalCode, phoneNumber, username, fundId) {
        return {
            id,
            number,
            fullName: `${firstName} ${lastName}`,
            fundName: fundName ? fundName : "-",
            nationalCode,
            phoneNumber,
            username,
        };
    }

    function getFundAdminsFromServer() {
        setTableLoading(true)
        service.getFundsAdminsList(
            page - 1,
            size,
            fullNameFilter,
            nationalCodeFilter
        ).then(response => {
            setFunds([])
            setTotalItems(response.numberOfItems)
            setPageCount(response.totalPage)

            response.data.map((item, index) => {
                setFunds(prev => [
                        ...prev,
                        prepareFundsListItem(
                            ((page - 1) * size) + index + 1,
                            item.id,
                            item.firstName,
                            item.lastName,
                            item.fundName,
                            item.nationalCode,
                            item.phoneNumber,
                            item.username,
                            item.fundId,
                        )
                    ]
                )
            })
        }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setTableLoading(false)
        })
    }


    function handleChangePagination(newPage) {
        setPage(newPage + 1)
    }


    const [openAddNewItemDialog, setOpenAddNewItemDialog] = useState(false);
    const handleOpenDialog = () => setOpenAddNewItemDialog(true)
    const handleCloseDialog = () => setOpenAddNewItemDialog(false)

    function handleAddNewItemToTable(item) {
        const newItems = addNewRowToTable(
            prepareFundsListItem(
                ((page - 1) * size) + 1,
                item.id,
                item.firstName,
                item.lastName,
                "-",
                item.nationalCode,
                item.phoneNumber,
                item.username,
            ),
            funds
        )

        setFunds(newItems)
        handleCloseDialog()
    }


    function handleSelectRow(_item) {
        let _title = ""
        funds.map((item) => {
            if (item.id === _item)
                _title = item.fullName
        })

        navigate(
            RouteHelper.FundAdminDetail.globalUrl.replace(":id", _item),
            {state: {title: _title}, replace: false}
        )
    }


    return (
        <>
            <Helmet>
                <title className="">{RouteHelper.FundsSuperAdmin.name}</title>
            </Helmet>
            <RaikoDefaultDialogPage
                onClose={handleCloseDialog}
                open={openAddNewItemDialog}
                pageTitle={"افزودن مدیر جدید"}
                dialogSize={DialogSize.SMALL}
            >
                <FundAddNewAdmin handleAddNewItemToTable={handleAddNewItemToTable}/>
            </RaikoDefaultDialogPage>

            <RaikoBaseContainer>
                <RaikoBreadcrumb breadCrumbItems={[
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.Funds.name,
                        ""
                    ),
                    raikoBreadCrumbItemGenerator(
                        RouteHelper.FundsSuperAdmin.name,
                        RouteHelper.FundsList.url
                    )
                ]}/>

                <RaikoBaseCardContainer>
                    <RaikoSectionContainer
                        title={"جستجو"}
                        subTitle={"برای جستجو عبارت مورد نظر خود را وارد نمایید."}
                    >
                        <RaikoGridTwoColumn>
                            <RaikoMaterialOutlinedInput labelText={"نام و نام خانوادگی"} value={fullName}
                                                        setValue={setFullName}/>
                            <RaikoMaterialOutlinedInput labelText={"کد ملی"} value={nationalCode}
                                                        setValue={setNationalCode}/>
                        </RaikoGridTwoColumn>
                    </RaikoSectionContainer>
                </RaikoBaseCardContainer>

                <RaikoBaseCardContainer>
                    <RaikoGridOneColumn>
                        <RaikoTableTitleContainer
                            title={"صندوق ها"}
                            amount={totalItems}
                            hasCreateNewItem
                            handleCreateNewItem={handleOpenDialog}
                        />
                        <RaikoCustomTable
                            header={header}
                            data={funds}
                            isLoading={tableLoading}
                            newPage={page}
                            pageCount={pageCount}
                            handlePaginationChange={handleChangePagination}
                            rowClicked={handleSelectRow}
                        />
                    </RaikoGridOneColumn>
                </RaikoBaseCardContainer>
            </RaikoBaseContainer>

        </>
    )
}


const header = [
    {
        id: "number",
        label: "#"
    }, {
        id: "fullName",
        label: "نام و نام خانوادگی"
    },
    {
        id: "username",
        label: "نام کاربری"
    },
    {
        id: "fundName",
        label: "صندوق"
    }, {
        id: "nationalCode",
        label: "کد ملی"
    }, {
        id: "phoneNumber",
        label: "شماره همراه"
    },
]
